<template>
  <v-card flat tile class="elevation-00" style="height: 100%">
    <v-card-title class="subtitle-1 ml-0 text-center">
      <v-spacer> </v-spacer>

      <div class="d-none d-sm-block text-left mt-md-2 mt-lg-0">
        <v-btn
          class="px-3 ml-2 caption primary--text"
          depressed
          @click="openDialog('trote')"
        >
          Trote
          <v-icon size="12" class="ml-1">far fa-thumbs-down</v-icon>
        </v-btn>

        <v-btn
          class="px-3 ml-2 caption primary--text"
          depressed
          @click="openDialog('engano')"
        >
          Engano
          <v-icon size="14" class="ml-1">far fa-times-circle</v-icon>
        </v-btn>

        <v-btn
          class="px-3 ml-2 caption primary--text"
          depressed
          @click="openDialog('informacao')"
        >
          Informação
          <v-icon size="18" class="ml-1">fas fa-info-circle</v-icon>
        </v-btn>

        <!--      <v-btn
                class="px-3 ml-2 caption primary&#45;&#45;text"
                depressed
                @click="cancelAttendance">
                &lt;!&ndash;TODO: coloca aqui o cancelamento&ndash;&gt;
                Cancelar Solicitação
                <v-icon size="12" class="ml-1">far fa-trash-alt</v-icon>
              </v-btn>-->
      </div>

      <v-dialog v-model="dialogTrote" width="400" persistent>
        <v-card>
          <v-card-title class="headline" primary-title>
            Informação do Trote
          </v-card-title>

          <v-card-text>
            <v-text-field
              autofocus
              v-model="telefone"
              v-mask="mask.telephone"
              label="Telefone"
              outlined
              dense
              hide-details
            >
            </v-text-field>

            <span v-show="!telefone" style="color: red">
              *número de telefone é obrigatório
            </span>
          </v-card-text>

          <v-divider> </v-divider>

          <v-card-actions>
            <v-spacer> </v-spacer>

            <v-btn color="primary" text @click="closeDialogs()">
              Cancelar
            </v-btn>

            <v-btn
              color="primary"
              text
              @click="saveTroteInfo()"
              :disabled="!telefone"
            >
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogEngano" width="400" persistent>
        <v-card>
          <v-card-title class="headline" primary-title>
            Informação do Engano
          </v-card-title>

          <v-card-text>
            <v-text-field
              autofocus
              v-model="telefone"
              v-mask="mask.telephone"
              label="Telefone"
              outlined
              dense
              hide-details
            >
            </v-text-field>

            <span v-show="!telefone" style="color: red">
              *número de telefone é obrigatório
            </span>
          </v-card-text>

          <v-divider> </v-divider>

          <v-card-actions>
            <v-spacer> </v-spacer>

            <v-btn color="primary" text @click="closeDialogs()">
              Cancelar
            </v-btn>

            <v-btn
              color="primary"
              text
              @click="saveEnganoInfo()"
              :disabled="!telefone"
              >Salvar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogInfomacao" width="400" persistent>
        <v-card>
          <v-card-title class="headline" primary-title>
            Descrição da informação
          </v-card-title>

          <v-card-text>
            <v-text-field
              autofocus
              v-model="telefone"
              v-mask="mask.telephone"
              label="Telefone"
              outlined
              dense
              hide-details
            >
            </v-text-field>

            <span v-show="!telefone" style="color: red">
              *número de telefone é obrigatório
            </span>

            <br /><br />

            <v-textarea
              outlined
              label="Descrição"
              v-model="descricaoInformacao"
              hide-details
            >
              <span v-show="!descricaoInformacao" style="color: red">
                *campo descrição é obrigatório*
              </span>
            </v-textarea>
          </v-card-text>

          <v-divider> </v-divider>

          <v-card-actions>
            <v-spacer> </v-spacer>

            <v-btn color="primary" text @click="closeDialogs()">
              Cancelar
            </v-btn>

            <v-btn
              color="primary"
              text
              @click="saveDescricaoInfo()"
              :disabled="!descricaoInformacao"
            >
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogCancelar" width="400" persistent>
        <v-card>
          <v-card-title class="headline" primary-title>
            Cancelar Solicitação
          </v-card-title>
          <v-card-text>
            <v-text-field
              autofocus
              v-model="telefone"
              v-mask="mask.telephone"
              label="Telefone"
              outlined
              dense
              hide-details
            ></v-text-field>
            <span v-show="!telefone" style="color: red"
              >*número de telefone é obrigatório</span
            >
            <br /><br />
            <v-textarea
              hide-details
              outlined
              label="Motivo"
              v-model="descricaoInformacao"
            ></v-textarea>
            <span v-show="!descricaoInformacao" style="color: red"
              >*campo motivo é obrigatório*</span
            >
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeDialogs()">Não</v-btn>
            <v-btn
              color="primary"
              :loading="loading"
              text
              @click="finalizeCancel()"
              :disabled="!descricaoInformacao"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer></v-spacer>
      <div class="d-sm-none text-left ml-5">
        <v-layout row wrap>
          <v-flex xs6 sm6>
            <v-btn class="caption primary--text" depressed>
              Trote
              <v-icon size="12" class="ml-1">far fa-thumbs-down</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs6 sm6>
            <v-btn class="caption primary--text" depressed>
              Regulation
              <v-icon size="12" class="ml-1">fas fa-user</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs6 sm6>
            <v-btn class="mt-3 caption primary--text" depressed>
              Engano
              <v-icon size="14" class="ml-1">far fa-times-circle</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs6 sm6>
            <v-btn class="mt-3 caption primary--text" depressed>
              Information
              <v-icon size="18" class="ml-1">fas fa-info-circle</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
    </v-card-title>
    <v-card-text class="py-0">
      <v-layout class="my-0" row>
        <v-flex lg6 md12 xs12 sm12>
          <v-container class="py-0">
            <v-form
              :class="$vuetify.breakpoint.name === 'lg' ? 'mb-12 pt-21' : ''"
              ref="formSolicitation"
              lazy-validation
            >
              <v-text-field
                v-model="telefone"
                v-mask="mask.telephone"
                label="Telefone"
                outlined
                dense
                :rules="telephoneRules"
              >
              </v-text-field>
              <v-text-field
                v-model="nome"
                :rules="nameRules"
                label="Nome"
                outlined
                dense
              >
              </v-text-field>
              <v-select
                v-model="typeClassification"
                :items="typesClassification"
                :rules="classificationRules"
                label="Tipo do chamado"
                outlined
                dense
              >
              </v-select>
              <v-combobox
                v-model="reasonClassification"
                :items="reasons"
                :rules="reasonRules"
                label="Natureza"
                outlined
                dense
                chips
              >
              </v-combobox>
            </v-form>
          </v-container>
        </v-flex>

        <v-flex lg6 md12 xs12 sm12>
          <!-- transferencia-->
          <v-container
            class="py-0"
            v-if="typeClassification === 'TRANSFERÊNCIA'"
          >
            <v-form ref="formTrasnf" lazy-validation>
              <h1 class="text-left body-2 primary--text">Origem</h1>
              <v-combobox
                v-model="source"
                :items="hospitals"
                dense
                clearable
                hide-selected
                outlined
                persistent-hint
                small-chips
                @change="
                  () => {
                    if (destiny && source.value === destiny.value) {
						destiny = undefined;
                    }
                  }
                "
              >
              </v-combobox>
              <h1 class="text-left body-2 primary--text">Destino</h1>
              <v-combobox
                v-model="destiny"
                :items="hospitalsDestine"
                dense
                clearable
                hide-selected
                outlined
                persistent-hint
                small-chips
              >
              </v-combobox>
            </v-form>
          </v-container>
          <!-- Atendimento-->
          <v-container class="py-0" v-else>
            <!--          <v-text-field
                        outlined
                        dense
                        label="Localização"
                        hide-details
                        class="py-0 mt-0 mb-5"
                        v-model="searchAddress"
                        :rules="addressRules"
                        append-icon="fas fa-search"
                        @click:append="searchinMap(searchAddress)">
                      </v-text-field>-->
            <v-form ref="formLocatization" lazy-validation>
              <v-text-field
                outlined
                label="Localização"
                dense
                class="py-0 mt-0 mb-5"
                v-model="searchAddress"
                :rules="addressRules"
                append-icon="fas fa-search"
                @click:append="searchinMap(searchAddress)"
              >
              </v-text-field>
            </v-form>
            <Gmaps
              :style="getStyleMaps()"
              ref="gmaps"
              v-on:locationFound="location = $event"
            >
            </Gmaps>
            <h4 v-if="location && location.address">
              Endereço: {{ location.address }}
            </h4>
            <v-dialog v-model="dialogAdress" width="500">
              <v-card>
                <v-card-title class="headline" primary-title
                  >Confirmação da localização
                </v-card-title>
                <v-card-text>
                  {{ location.address }}
                  <v-textarea
                    class="mt-5"
                    outlined
                    label="Informações Complementares"
                    v-model="descricaoLocal"
                  >
                  </v-textarea>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialogAdress = false">
                    OK
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-text-field
              style="padding-top: 10px"
              dense
              label="Ponto de Referência"
              v-model="reference_point"
              outlined
              hide-details
              clearable
            >
            </v-text-field>
            <br />
            <v-text-field
              clearable
              dense
              v-model="observation"
              label="Observação"
              outlined
            >
            </v-text-field>
          </v-container>
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>
    </v-card-text>
  </v-card>
</template>

<script>
import Gmaps from "../../components/Gmaps";
import { mask } from "vue-the-mask";
export default {
  components: {
    Gmaps,
  },

  directives: {
    mask,
  },

  props: ["doctor", "callObj"],

  data: () => ({
    item: ["28 de Agosto", "João Lucio"],

    observation: "",
    reference_point: "",
    source: undefined,
    destiny: undefined,
    loading: false,
    dialogTrote: false,
    dialogEngano: false,
    dialogInfomacao: false,
    dialogCancelar: false,
    dialogAdress: false,
    telefoneDialogs: "",
    descricaoInformacao: "",
    location: {},
    searchAddress: "",
    descricaoLocal: "",
    mask: {
      telephone: "(##) #####-####",
    },
    nome: "",
    telefone: "",
    nickName: "",
    reason: "",
    reasons: [
      "Clínico",
      "Trauma",
      "Obstétrico",
      "Pediátrico",
      "Psiquiátrico",
      "Outros",
    ],
    reference: "",
    references: ["Reference1", "References2"],
    typeClassification: "",
    typesClassification: [
      "ATENDIMENTO",
      //"DESISTÊNCIA",
      //"ORIENTAÇÃO",
      //"QUEDA DE LIGAÇÃO",
      //"SERVIÇO SOCIAL",
      "TRANSFERÊNCIA",
      //"TRANSPORTE"
    ],
    reasonClassification: "",
    telephoneRules: [
      (v) => !!v || "É necessário preencher o telefone para continuar!",
      (v) =>
        (v && /\(\d{2}\)\s\d{4,5}-?\d{4}/g.test(v)) || "Telefone Inválido!",
    ],
    nameRules: [
      (v) => !!v || "Nome do solicitante precisa ser preenchido!",
      (v) =>
        (v && /^[A-Za-zàáãäâèéëêìíïîòóõöôùúüûç ]+$/.test(v)) ||
        "Somente letras!",
    ],
    classificationRules: [
      (v) => !!v || "Tipo do chamdado precisa ser selecionado!",
    ],
    reasonRules: [(v) => !!v || "Razão da chamada precisa ser selecionada!"],
    addressRules: [(v) => !!v || "A localização precisa ser preenchida!"],
  }),

  computed: {
    hospitals() {
      let h = [];
      h = this.$store.getters.hospitals.map((hospital) => {
        return {
          text: hospital.name,
          value: hospital.id,
        };
      });
      /*
		hospital = {
			address: Object
			address_id: 7
			category: null
			contact: Object
			contact_id: 2
			created_at: (...)
			hospital_type_id: (...)
			id: 2
			name: "PLATÃO"
			services: Array(5)
			status: 1
			updated_at
		}
	  */
      return h;
    },
    hospitalsDestine() {
      const isDifFOrigem = (hospital) => {
        return this.source && hospital.value !== this.source.value;
      };
      let filtred = this.hospitals.filter(isDifFOrigem);
      return filtred;
    },
  },
  watch: {
    location(value) {
      if (
        value &&
        value.address &&
        value.address !== "" &&
        value.address !== "Manaus, AM, Brasil"
      ) {
        //this.dialogAdress = true;
      }
    },

    callObj(value) {
      if (value && this.doctor) {
        this.telefone = value.phone;
        this.nome = value.name;
        this.reasonClassification = value.reason;
        this.typeClassification = value.type ? value.type : "ATENDIMENTOS";
        this.searchAddress = value.address;
        this.searchinMap(value.address);
      }
    },
  },

  mounted() {
    window.addEventListener("keydown", this.handleEnter);
  },

  destroyed() {
    window.removeEventListener("keydown", this.handleEnter);
  },

  created() {
    this.$store.dispatch("loadHospitals");
  },

  methods: {
    getStyleMaps() {
      if (
        this.$vuetify.breakpoint.name == "xs" ||
        this.$vuetify.breakpoint.name == "sm"
      ) {
        return "height:400px";
      } else if (this.$vuetify.breakpoint.name == "lg") {
        return "height:220px";
      } else {
        return "height:220px";
      }
    },

    openDialog(val) {
      if (val === "trote") this.dialogTrote = true;
      else if (val === "engano") this.dialogEngano = true;
      else if (val === "informacao") this.dialogInfomacao = true;
      else if (val === "cancelarSolicitacao") this.dialogCancelar = true;
    },

    saveTroteInfo() {
      //salva em uma lista
      //chamar o loader
      this.closeDialogs();
    },

    saveEnganoInfo() {
      //salva em uma lista
      //chamar o loader
      this.closeDialogs();
    },

    saveDescricaoInfo() {
      //salva em uma lista
      //chamar o loader
      this.closeDialogs();
    },

    closeDialogs() {
      this.dialogTrote = false;
      this.dialogEngano = false;
      this.dialogInfomacao = false;
      this.dialogCancelar = false;
      this.descricaoInformacao = "";
      this.telefoneDialogs = "";
    },

    handleEnter(e) {
      if (e.key === "Enter") {
        this.searchinMap(this.searchAddress);
      }
    },

    searchinMap(address) {
      if (this.$refs.gmaps) {
        this.$refs.gmaps.clear();
        this.$refs.gmaps.positionAddress(address);
      }
    },

    cancelAttendance() {
      this.dialogCancelar = true;
      if (this.callObj && this.doctor) {
        //console.log('selecionado',this.callObj)
        this.openDialog("cancelarSolicitacao");
      } else {
        this.$emit(
          "alertMessage",
          "É necessário selecionar a chamada que você deseja cancelar!"
        );
      }
    },

    setSolicitationInfoCall() {
      if (this.typeClassification === "TRANSFERÊNCIA") {
        let validate = this.$refs.formTrasnf.validate();
        console.log("Validate->", validate);
        if (validate) {
          this.$store.dispatch("setSolicitationInfoCall", {
            name: this.nome,
            phone: this.telefone,
            device: "desktop",
            location: {
              from_hospital_id: this.item.findIndex((i) => i === this.source.value),
              to_hospital_id: this.item.findIndex((i) => i === this.destiny.value),
            },
            reason: this.reasonClassification,
            type: "transferencia",
          });
        }
        return validate;
      } else {
        let validate =
          this.$refs.formSolicitation.validate() &&
          this.$refs.formLocatization.validate();
        console.log("Validate->", validate);
        if (validate) {
          this.$store.dispatch("setSolicitationInfoCall", {
            name: this.nome,
            phone: this.telefone,
            device: "desktop",
            reason: this.reasonClassification,
            status: 1,
            location: Object.assign(
              {},
              { ...this.location, reference_point: this.reference_point }
            ),
            type: "atendimento",
          });
        }
        return validate;
      }
    },

    clearStep() {
      console.log("Clear Step");
      this.$refs.formSolicitation.resetValidation();
      this.$refs.formLocatization.resetValidation();
      this.$refs.formSolicitation.reset();
      this.$refs.formLocatization.reset();
      this.location = {};
      this.searchinMap(undefined);
    },
    /*    setSolicitationInfoCall (){
          let validate = true;
          validate = this.typeClassification === "TRANSFERÊNCIA"?this.$refs.formSolicitation.validate():this.$refs.formLocatization.validate();
          if(validate){
            if( this.typeClassification === "TRANSFERÊNCIA" ){
              this.$store.dispatch('setSolicitationInfoCall',{
                name: this.nome,
                phone: this.telefone,
                device: "desktop",
                location: {
                  from_hospital_id: this.item.findIndex((i) =>i===this.source),
                  to_hospital_id: this.item.findIndex((i)=>i===this.destiny),
                },
                reason: this.reasonClassification,
                type: this.typeClassification,

              })
            } else{
             this.$store.dispatch('setSolicitationInfoCall',{
              name: this.nome,
              phone: this.telefone,
              device: "desktop",
              reason: this.reasonClassification,
              observation: this.observation,
              status: 1,
              location: Object.assign({}, {...this.location, reference_point:this.reference_point}),
              type: this.typeClassification,
            })
            }
          }
          return validate
        },
        clearStep(){
          if( this.$refs.formSolicitation ){
            console.log('reset where')
            this.$refs.formSolicitation.resetValidation()
            this.$refs.formSolicitation.reset()
          }
          if(this.$refs.formLocatization){
            console.log('reset where')
            this.reference_point = ""
            this.observation = "";
            this.$refs.formLocatization.resetValidation()
            this.$refs.formLocatization.reset()
          }
          this.location = {}
          this.searchinMap(undefined)
        },*/

    finalizeCancel() {
      this.loading = true;
      this.$store
        .dispatch("updateSelectedCall", { cancel: true })
        .then((response) => {
          this.loading = false;
          //salva em uma lista
          //chamar o loader
          this.closeDialogs();
          this.$store.dispatch("loadAttendances");
        })
        .catch(() => {
          this.loading = false;
          this.closeDialogs();
        });
    },
  },
};
</script>

<style scoped>
.not-uppercase {
  text-transform: none;
}
</style>

